import styled from '@emotion/styled';
import HighlightOff from '@material-ui/icons/HighlightOff';
import { ClassAttributes, createElement, useState } from 'react';

import { File as UploadedFile } from '../../../../../graphql/generated/graphql';
import { OnUploadProgress } from '../../../../../service/persistent/FileUploader';
import { SPACING_UNIT } from '../../../../constant/spacing';
import AspectRatioFixed from '../../../primitive/AspectRatioFixed';
import FileUploader from '../../FileUploader';
import FileUploaderProcessing from '../../FileUploaderProcessing';
import MediaPlayer from '../../MediaPlayer';
interface Props {
  uploadedFile: UploadedFile | null;
  uploadingCreative: boolean;
  uploadCreative: (file: File | null, onUploadProgress?: OnUploadProgress) => void;
  className?: string;
}

const CreativeUploader = ({
  uploadedFile,
  uploadingCreative,
  uploadCreative,
  className,
}: ClassAttributes<HTMLElement> & Props) => {
  const [progress, updateProgress] = useState(0);
  let content = null;

  const onUploadProgress = (ev: ProgressEvent) => {
    updateProgress(Math.round((ev.loaded * 100) / ev.total));
  };

  const onRequestFileUpload = (files: FileList) => {
    updateProgress(0);
    uploadCreative(files[0], onUploadProgress);
  };

  if (uploadingCreative) {
    content = <FileUploaderProcessing progress={progress} />;
  } else if (uploadedFile) {
    content = (
      <CancelableVideoScreen>
        <MediaPlayer mimeType={uploadedFile.mimeType} url={uploadedFile.url} />
        <CancelIcon
          onClick={() => {
            uploadCreative(null);
          }}
        />
      </CancelableVideoScreen>
    );
  } else {
    content = <FileUploader onRequestFileUpload={onRequestFileUpload} />;
  }

  return (
    <Root aspectRatio={[4, 3]} className={className}>
      {content}
    </Root>
  );
};

const Root = styled(AspectRatioFixed)();

const CancelableVideoScreen = styled('div')({ position: 'relative' });

const CancelIcon = styled(HighlightOff)({
  position: 'absolute',
  top: SPACING_UNIT,
  right: SPACING_UNIT,
  color: '#fff',
  width: 32,
  height: 32,
  cursor: 'pointer',
  '&:hover': {
    opacity: 0.8,
  },
});

export default CreativeUploader;
